import PropTypes from 'prop-types'

export default function InventoryForm({ handleSubmit, handleChange, fields }) {
  const {
    Description,
    Location,
    IsTool,
    IsInControlVisio,
    IsInChecklistRam,
    IsInChecklistMaq
  } = fields

  return (
    <>
      <form className="container flex flex-wrap" onSubmit={handleSubmit}>
        <div className="w-1/2 p-2">
          <label
            className="block mb-2 text-grey-darker text-md font-ms-semi col-start-full"
            htmlFor="Description"
          >
            Descripció
          </label>

          <input
            className="w-full px-3 py-2 border border-gray-300 rounded shadow appearance-none pl-7 text-grey-darker"
            name="Description"
            type="text"
            value={Description}
            onChange={(e) => handleChange(e)}
          />
        </div>

        <div className="w-1/2 p-2">
          <label
            className="block mb-2 text-grey-darker text-md font-ms-semi col-start-full"
            htmlFor="Position"
          >
            Lloc
          </label>

          <select
            className="w-full px-3 py-2 border border-gray-300 rounded shadow appearance-none pl-7 text-grey-darker"
            name="Location"
            type="text"
            value={Location}
            onChange={(e) => handleChange(e)}
          >
            <option value="">Escull</option>
            <option value="CETRIKO">Cetriko</option>
            <option value="4KF">4KF</option>
          </select>
        </div>

        <div className="flex items-center w-1/2 p-2 space-x-2">
          <input
            type="checkbox"
            className="w-6 h-6 cursor-pointer"
            onClick={(e) => {
              handleChange({
                target: {
                  name: e.target.name,
                  value: e.target.checked
                }
              })
            }}
            name="IsTool"
            checked={IsTool}
          />

          <label
            className="block text-grey-darker text-md font-ms-semi col-start-full"
            htmlFor="IsTool"
          >
            És una eina?
          </label>
        </div>

        <div className="flex items-center w-1/2 p-2 space-x-2">
          <input
            type="checkbox"
            className="w-6 h-6 cursor-pointer"
            onClick={(e) => {
              handleChange({
                target: {
                  name: e.target.name,
                  value: e.target.checked
                }
              })
            }}
            name="IsInControlVisio"
            checked={IsInControlVisio}
          />

          <label
            className="block text-grey-darker text-md font-ms-semi col-start-full"
            htmlFor="IsInControlVisio"
          >
            Mostrar a Control Visió
          </label>
        </div>

        <div className="flex items-center w-1/2 p-2 space-x-2">
          <input
            type="checkbox"
            className="w-6 h-6 cursor-pointer"
            onClick={(e) => {
              handleChange({
                target: {
                  name: e.target.name,
                  value: e.target.checked
                }
              })
            }}
            name="IsInChecklistRam"
            checked={IsInChecklistRam}
          />

          <label
            className="block text-grey-darker text-md font-ms-semi col-start-full"
            htmlFor="IsInChecklistRam"
          >
            Mostrar a Checklist (RAM)
          </label>
        </div>

        <div className="flex items-center w-1/2 p-2 space-x-2">
          <input
            type="checkbox"
            className="w-6 h-6 cursor-pointer"
            onClick={(e) => {
              handleChange({
                target: {
                  name: e.target.name,
                  value: e.target.checked
                }
              })
            }}
            name="IsInChecklistMaq"
            checked={IsInChecklistMaq}
          />

          <label
            className="block text-grey-darker text-md font-ms-semi col-start-full"
            htmlFor="IsInChecklistMaq"
          >
            Mostrar a Checklist (MAQ)
          </label>
        </div>

        <button
          className="px-4 py-2 mt-2 ml-auto mr-2 bg-transparent border rounded hover:bg-secondary text-primary font-ms-semi hover:text-white border-primary hover:border-transparent h-1/2"
          type="submit"
        >
          GUARDAR
        </button>
      </form>
    </>
  )
}

InventoryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  fields: PropTypes.object,
  isUpdate: PropTypes.any
}
